<template>
    <div
        class="payments-page container-fluid page-card admin-weflix-payment weeduc-admin-page"
    >
        <header class="weeduc-admin-page__header">
            <div class="weeduc-admin-page__header-lead">
                <TitlePage
                    title="Pagamentos"
                    subtitle="Gerencie planos de assinatura e cupons de desconto."
                    :hasMargin="false"
                />
            </div>
        </header>

        <div class="weeduc-admin-page__shell">
            <div class="weeduc-admin-page__panel">
                <nav class="weeduc-admin-tabs" aria-label="Seções de pagamentos">
                    <button
                        type="button"
                        class="weeduc-admin-tab"
                        :class="{ 'weeduc-admin-tab--active': isActiveTab(1) }"
                        @click="setActiveTab(1)"
                    >
                        Planos
                    </button>
                    <button
                        type="button"
                        class="weeduc-admin-tab"
                        :class="{ 'weeduc-admin-tab--active': isActiveTab(2) }"
                        @click="setActiveTab(2)"
                    >
                        Cupons de Desconto
                    </button>
                </nav>

                <div class="payments-panels">
                    <section
                        v-show="isActiveTab(1)"
                        class="section config-form primary payments-section"
                        :class="{ active: isActiveTab(1) }"
                    >
                        <Plan />
                    </section>
                    <section
                        v-show="isActiveTab(2)"
                        class="section config-form primary payments-section"
                        :class="{ active: isActiveTab(2) }"
                    >
                        <Cupom />
                    </section>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Plan from '@/components/Weflix/Payment/plan.vue';
    import Cupom from '@/components/Weflix/Payment/cupom.vue';
    import TitlePage from '@/components/Weflix/titlePage.vue';

    export default {
        data() {
            return {
                activeTab: 1,
            };
        },
        props: {},
        components: {
            Plan,
            Cupom,
            TitlePage,
        },
        methods: {
            setActiveTab(tabNumber) {
                this.activeTab = tabNumber;
            },
            isActiveTab(tabNumber) {
                return this.activeTab === tabNumber;
            },
        },
        created() {},
    };
</script>

<style>
    @import url('@/css/weflix/payment-plans.css');
</style>

<style scoped>
    @import url(./global.css);
    @import url('@/css/weeduc/admin/dashboard-weflix-shell.css');

    .payments-page.container-fluid.page-card {
        background: #f4f5f8;
        border-radius: 16px;
        padding: 0 0 1rem;
        box-shadow: 0 1px 3px rgba(37, 8, 145, 0.06);
    }

    .payments-section.section.config-form.primary {
        background: transparent;
        overflow-x: hidden;
        box-shadow: none;
    }

    .payments-section.section.config-form.primary.active {
        display: block;
        height: auto;
        overflow: visible;
    }

    /* Conteúdo Plan / Cupom */
    .payments-panels :deep(.plans) {
        background: #fafbfc;
        border: 1px solid #f0f2f5;
        border-radius: 12px;
        overflow: hidden;
        padding: 0;
    }

    .payments-panels :deep(.titlelayoutLayout1) {
        display: flex !important;
        flex-wrap: wrap;
        align-items: flex-start;
        justify-content: space-between;
        gap: 1rem;
        padding: 1rem 1.25rem !important;
        border-bottom: 1px solid #e8eaf0;
        margin: 0 !important;
    }

    .payments-panels :deep(.titlelayoutLayout1 .titlelayoutGeneric) {
        margin: 0 !important;
        padding: 0 !important;
        border-bottom: none !important;
        flex: 1;
        min-width: 200px;
    }

    .payments-panels :deep(.titlelayoutLayout1 .titlelayoutGeneric.has-margin) {
        margin: 0 !important;
    }

    .payments-panels :deep(.titlelayoutLayout1 .titlelayoutGeneric h3) {
        font-size: 1.125rem;
        font-weight: 700;
        color: #1a1d26;
        margin: 0 0 0.35rem;
    }

    .payments-panels :deep(.titlelayoutLayout1 .titlelayoutGeneric small) {
        display: block;
        font-size: 0.875rem;
        color: #5c6370;
        line-height: 1.45;
    }

    .payments-panels :deep(.titlelayoutLayout1 .btnNew) {
        flex-shrink: 0;
        align-self: flex-start;
    }

    .payments-panels :deep(.plans > .plan) {
        padding: 1.25rem;
        background: transparent;
    }

    /* Desfaz absolute do btnNew em plan.vue / cupom.vue */
    .payments-panels :deep(.titlelayoutLayout1 .btnNew),
    .payments-panels :deep(button.btnNew.v-btn) {
        position: relative !important;
        top: auto !important;
        right: auto !important;
    }

    .payments-panels :deep(.plans .itens) {
        display: flex;
        flex-direction: column;
        gap: 0.75rem;
    }

    @media (min-width: 768px) {
        /* Planos: grid; cupons: uma coluna (evita cards estreitos + texto largo) */
        .payments-panels :deep(.plans .itens:not(:has(> .couponItem))) {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
            gap: 1rem;
        }

        .payments-panels :deep(.plans .itens:has(> .couponItem)) {
            display: flex;
            flex-direction: column;
            gap: 1rem;
        }
    }

    .payments-panels :deep(.item.myPlanWeflixStyle),
    .payments-panels :deep(.item.couponItem) {
        background: #fff !important;
        border: 1px solid #e8eaf0 !important;
        border-radius: 12px !important;
        padding: 1rem 1.15rem !important;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
    }

    .payments-panels :deep(.item.myPlanWeflixStyle .infoItemPlan) {
        flex: 1;
        min-width: 0;
    }

    .payments-panels :deep(.actionsItem) {
        gap: 0.5rem !important;
        flex-shrink: 0;
    }

    .payments-panels :deep(.btnIcon) {
        border-radius: 10px;
        transition: background 0.2s ease, color 0.2s ease;
    }

    .payments-panels :deep(.btnIcon:hover) {
        background: #eef0fc;
    }

    /* Trial: classe typo seondary no componente filho */
    .payments-panels :deep(.titlelayoutLayout.seondary) {
        margin-top: 0 !important;
        margin-bottom: 0 !important;
        padding: 1.25rem !important;
        border-top: 1px solid #e8eaf0;
        border-bottom: 1px solid #e8eaf0;
        background: #fff;
    }

    .payments-panels :deep(.titlelayoutLayout.seondary h3) {
        font-size: 1.05rem;
        font-weight: 700;
        color: #1a1d26;
    }

    .payments-panels :deep(.titlelayoutLayout.seondary small) {
        display: block;
        margin-top: 0.35rem;
        color: #5c6370;
        font-size: 0.875rem;
        line-height: 1.45;
    }

    .payments-panels :deep(.trial) {
        padding: 1.25rem;
        background: #fff;
        border-bottom: 1px solid #e8eaf0;
    }

    .payments-panels :deep(.trial > p) {
        margin: 0 0 1rem;
        text-align: left;
        color: #5c6370;
        font-size: 0.9375rem;
    }

    .payments-panels :deep(.cardTrial) {
        border-radius: 12px !important;
        border: 1px solid #e8eaf0 !important;
        box-shadow: none !important;
    }

    .payments-panels :deep(.trial .warning) {
        max-width: 100% !important;
        width: 100% !important;
        margin: 0.75rem 0 0 !important;
        padding: 0.75rem 1rem !important;
        border-radius: 10px;
        border-color: #e8eaf0;
        background: #fafbfc;
    }

    /* Barra Salvar (irmão imediato de section.plans em plan.vue) */
    .payments-panels :deep(section.plans.flex-grow-1 + div.d-flex) {
        margin-top: 0 !important;
        padding: 1.25rem 1.25rem 1rem !important;
        border-top: 1px solid #e8eaf0;
        background: #fafbfc;
    }

    /* Cupons: layout fluido dentro do card (remove absolute / largura fixa) */
    .payments-panels :deep(.item.couponItem .expiration.couponItem) {
        position: static !important;
        right: auto !important;
    }

    .payments-panels :deep(.infoItemPlan.couponItem) {
        width: auto !important;
        max-width: 100%;
        flex: 1;
        min-width: 0;
    }

    .payments-panels :deep(.itemContainerRow.couponItem) {
        flex: 1;
        min-width: 0;
        gap: 1rem !important;
    }

    .payments-panels :deep(.pagination) {
        margin-top: 1rem !important;
        padding-top: 1rem;
        border-top: 1px solid #e8eaf0;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        gap: 0.5rem;
    }

    .payments-panels :deep(.new-plan-modal-card) {
        border-radius: 12px;
        overflow: hidden;
    }

    @media (max-width: 600px) {
        .payments-tabs {
            flex-wrap: nowrap;
            overflow-x: auto;
            -webkit-overflow-scrolling: touch;
            gap: 0.4rem;
            padding: 0.6rem;
        }

        .payments-tabs .link a.link-content {
            white-space: nowrap;
        }

        .payments-panels :deep(.titlelayoutLayout1) {
            flex-direction: column;
            align-items: stretch;
        }

        .payments-panels :deep(.titlelayoutLayout1 .btnNew) {
            width: 100%;
        }
    }
</style>
